module.exports = __webpack_public_path__ + "static/media/IMG_E2899a.da68796d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/IMG_E2899a.jpg
// module id = 161
// module chunks = 0